"use client";

import React, { useEffect } from "react";

export default function ContentProtection({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const prevent = (e: KeyboardEvent) => {
      // Guard against synthetic/key events that don't expose a usable key.
      // Some browsers / extensions fire KeyboardEvent with key=undefined,
      // which crashes `.toLowerCase()` and breaks the whole document.
      const key = ((e.key as string) ?? "").toString().toLowerCase();
      const ctrlOrMeta = e.ctrlKey || e.metaKey;
      if (
        (ctrlOrMeta &&
          ["c", "u", "s", "p", "shift+i", "shift+c", "shift+j"].includes(
            key,
          )) ||
        key === "f12" ||
        (ctrlOrMeta && e.shiftKey && key === "i") ||
        (ctrlOrMeta && e.shiftKey && key === "c") ||
        (ctrlOrMeta && e.shiftKey && key === "j")
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const blockContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    const blockSelectStart = (e: Event) => {
      e.preventDefault();
    };

    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        document.body.style.filter = "blur(8px)";
      } else {
        document.body.style.filter = "";
      }
    };

    document.addEventListener("keydown", prevent, true);
    document.addEventListener("contextmenu", blockContextMenu, true);
    document.addEventListener("selectstart", blockSelectStart, true);
    document.addEventListener("visibilitychange", handleVisibility);

    document.body.style.userSelect = "none";
    document.body.style.webkitUserSelect = "none";

    return () => {
      document.removeEventListener("keydown", prevent, true);
      document.removeEventListener("contextmenu", blockContextMenu, true);
      document.removeEventListener("selectstart", blockSelectStart, true);
      document.removeEventListener("visibilitychange", handleVisibility);
      document.body.style.userSelect = "";
      document.body.style.webkitUserSelect = "";
      document.body.style.filter = "";
    };
  }, []);

  return <>{children}</>;
}
